import React from "react";

import {
  TabButton,
  TabButtonsContainer,
  TabContainer,
  EditableInput,
} from "./styles";
import Trash from "../actions/icons/Trash";
import ChevronLeft from "../actions/icons/ChevronLeft";
import ChevronRight from "../actions/icons/ChevronRight";
import { useCardsStore } from "../../../../stores/use-cards-store";
import { useTranslation } from "react-i18next";

const Tab = ({
  isPreview = false,
  isEditable = false,
  label,
  tabs,
  isSelected = false,
  onTabClick = () => {},
  onDeleteClick = () => {},
  onReorderClick = () => {},
  movePermissions = {},
}) => {
  const { updateCardsTabs, cardsTab } = useCardsStore((state) => ({
    updateCardsTabs: state.updateCardsTabs,
    cardsTab: state.cardsTab,
  }));
  const { left, right } = movePermissions;

  const { t } = useTranslation();

  return (
    <TabContainer
      isSelected={isSelected}
      onClick={onTabClick}
      onMouseLeave={() => {
        if (!label) {
          const newTabs = tabs.map((tab) =>
            tab.id === cardsTab.id ? { ...tab, text: t("tab-name") } : tab
          );
          updateCardsTabs(newTabs);
        }
      }}
    >
      {isSelected && !isPreview && (
        <TabButton
          onClick={(event) => {
            event.stopPropagation();
            onDeleteClick();
          }}
        >
          <Trash />
        </TabButton>
      )}

      {isEditable ? (
        <EditableInput
          placeholder={t("insert-text")}
          value={label}
          onChange={({ target: { value: text } }) => {
            const newTabs = tabs.map((tab) =>
              tab.id === cardsTab.id ? { ...tab, text } : tab
            );
            updateCardsTabs(newTabs);
          }}
        />
      ) : (
        label
      )}

      {isSelected && !isPreview && (
        <TabButtonsContainer>
          <TabButton
            hasOpacity={left}
            onClick={() => onReorderClick({ direction: "left" })}
          >
            <ChevronLeft />
          </TabButton>
          <TabButton
            hasOpacity={right}
            onClick={() => onReorderClick({ direction: "right" })}
          >
            <ChevronRight />
          </TabButton>
        </TabButtonsContainer>
      )}
    </TabContainer>
  );
};

export default Tab;
